import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RoleGuardService } from './auth/role-guard';
import { AuthorityEnum } from './auth/authority-enum.model';
import { DatasourcesComponent, MetadataEditorComponent } from 'dashboard-lib';
import { DashboardWrapperComponent } from './components/dashboard-wrapper/dashboard-wrapper.component';
import { ECHARTS_CORE_PROVIDERS } from './echarts.providers';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/landing-page/landing-page.component').then((m) => m.LandingPageComponent),
    pathMatch: 'full',
    canActivate: [RoleGuardService],
    data: {
      roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
    }
  },
  {
    path: 'app',
    canActivateChild: [MsalGuard],
    children: [
      {
        path: 'overview',
        loadComponent: () => import('./components/overview/overview.component').then((m) => m.OverviewComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'product-detail/:pid',
        loadComponent: () =>
          import('./components/purchase-product/product-detail/product-detail.component').then(
            (m) => m.ProductDetailComponent
          ),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.PURCHASE]
        }
      },
      {
        path: 'overview-online',
        loadComponent: () =>
          import('./components/overview/overview-web/overview-web.component').then((m) => m.OverviewWebComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'overview-store',
        loadComponent: () =>
          import('./components/overview/overview-per/overview-per.component').then((m) => m.OverviewPerComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'overview-phone',
        loadComponent: () =>
          import('./components/overview/overview-tel/overview-tel.component').then((m) => m.OverviewTelComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'order-channel',
        loadComponent: () =>
          import('./components/overview/order-channel/order-channel.component').then((m) => m.OrderChannelComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'pivot-adv-med-tg-perf',
        loadComponent: () =>
          import('./components/pivot-adv-med-tg-perf/pivot-adv-med-tg-perf.component').then(
            (m) => m.PivotAdvMedTgPerfComponent
          ),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING, AuthorityEnum.DEVELOPER]
        }
      },
      {
        path: 'pivot-ads-cost-clicks',
        loadComponent: () =>
          import('./components/pivot-ads-cost-clicks/pivot-ads-cost-clicks.component').then(
            (m) => m.PivotAdsCostClicksComponent
          ),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'pivot-maileon-overview',
        loadComponent: () =>
          import('./components/pivot-maileon-overview/pivot-maileon-overview.component').then(
            (m) => m.PivotMaileonOverviewComponent
          ),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'pivot-matomo-last-click',
        loadComponent: () =>
          import('./components/pivot-matomo-last-click/pivot-matomo-last-click.component').then(
            (m) => m.PivotMatomoLastClickComponent
          ),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'revenue-plan-year',
        loadComponent: () =>
          import('./components/revenue-plan-year/revenue-plan-year.component').then((m) => m.RevenuePlanYearComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'revenue-plan-day',
        loadComponent: () =>
          import('./components/revenue-plan-day-chart/revenue-plan-day-chart.component').then(
            (m) => m.RevenuePlanDayChartComponent
          ),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'overview-gantt',
        loadComponent: () => import('./components/overview/gantt/gantt.component').then((m) => m.GanttComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'campaign',
        loadComponent: () => import('./components/campaign/campaign.component').then((m) => m.CampaignComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'catalogue',
        loadComponent: () => import('./components/catalogue/catalogue.component').then((m) => m.CatalogueComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'mailing',
        loadComponent: () => import('./components/mailing/mailing.component').then((m) => m.MailingComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'newsletter',
        loadComponent: () => import('./components/newsletter/newsletter.component').then((m) => m.NewsletterComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'event',
        loadComponent: () => import('./components/event/event.component').then((m) => m.EventComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'products',
        loadComponent: () => import('./components/product/product.component').then((m) => m.ProductComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.DEVELOPER]
        }
      },
      {
        path: 'new-products',
        loadComponent: () =>
          import('./components/new-product/new-product.component').then((m) => m.NewProductComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'version-products/:versionId',
        loadComponent: () =>
          import('./components/version-product/version-product.component').then((m) => m.VersionProductComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'products-kpi',
        loadComponent: () =>
          import('./components/renner-product/renner-product.component').then((m) => m.RennerProductComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.DEVELOPER]
        }
      },
      {
        path: 'purchase-products',
        loadComponent: () =>
          import('./components/purchase-product/purchase-product.component').then((m) => m.PurchaseProductComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.PURCHASE]
        }
      },
      {
        path: 'loading-stand',
        loadComponent: () =>
          import('./components/loading-stand/loading-stand.component').then((m) => m.LoadingStandComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'stammdaten',
        loadComponent: () => import('./components/stammdaten/stammdaten.component').then((m) => m.StammdatenComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./components/details/details.component').then((m) => m.DetailsComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'event-ort',
        loadComponent: () => import('./components/event-ort/event-ort.component').then((m) => m.EventOrtComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'marketing-plan',
        loadComponent: () =>
          import('./components/marketing-plan/marketing-plan.component').then((m) => m.MarketingPlanComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'step-details',
        loadComponent: () =>
          import('./components/step-details/step-details.component').then((m) => m.StepDetailsComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'planperiode',
        loadComponent: () =>
          import('./components/planperiode/planperiode.component').then((m) => m.PlanperiodeComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'surcharge-step',
        loadComponent: () =>
          import('./components/plan-surcharge-step-list/plan-surcharge-step-list.component').then(
            (m) => m.PlanSurchargeStepListComponent
          ),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./components/user-management/user-management.component').then((m) => m.UserManagementComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.DEVELOPER]
        }
      },
      {
        path: 'marketing-preview',
        loadComponent: () =>
          import('./components/marketing-plan-preview/marketing-plan-preview.component').then(
            (m) => m.MarketingPlanPreviewComponent
          ),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'product-plan-history/:productId',
        loadComponent: () =>
          import('./components/product-plan-history/product-plan-history.component').then(
            (m) => m.ProductPlanHistoryComponent
          ),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'step-scenarios',
        loadComponent: () =>
          import('./components/step-scenario/step-scenario.component').then((m) => m.StepScenarioComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'step-scenario-preview',
        loadComponent: () =>
          import('./components/step-scenario-preview/step-scenario-preview.component').then(
            (m) => m.StepScenarioPreviewComponent
          ),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.DEVELOPER]
        }
      },
      {
        path: 'step-tree',
        loadComponent: () => import('./components/step-tree/step-tree.component').then((m) => m.StepTreeComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN]
        }
      },
      {
        path: 'step-preview',
        loadComponent: () =>
          import('./components/step-preview/step-preview.component').then((m) => m.StepPreviewComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.DEVELOPER]
        }
      },
      {
        path: 'revenue-forecast',
        loadComponent: () =>
          import('./components/revenue-forecast/revenue-forecast.component').then((m) => m.RevenueForecastComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.DEVELOPER]
        }
      },

      {
        path: 'visualizations',
        providers: ECHARTS_CORE_PROVIDERS,
        component: DashboardWrapperComponent,
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.DEVELOPER, AuthorityEnum.ADMIN, AuthorityEnum.PURCHASE, AuthorityEnum.MARKETING]
        }
      },
      {
        path: 'datasources',
        component: DatasourcesComponent,
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.DEVELOPER]
        }
      },
      {
        path: 'metadata-editor',
        component: MetadataEditorComponent,
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.DEVELOPER]
        }
      },

      {
        path: 'error',
        loadComponent: () => import('./components/error/error.component').then((m) => m.ErrorComponent)
      },
      {
        path: '**',
        loadComponent: () => import('./components/welcome/welcome.component').then((m) => m.WelcomeComponent),
        canActivate: [RoleGuardService],
        data: {
          roles: [AuthorityEnum.ADMIN, AuthorityEnum.PURCHASE, AuthorityEnum.DEVELOPER]
        }
      }
    ]
  }
];
